// Vendor
import * as React from 'react';

// Types
interface Props {
  size: number;
  className?: string;
}

export const PaddedContent: React.SFC<Props> = ({
  size,
  className,
  children
}) => (
  <div className={className} style={{padding: `${size}px`}}>
    {children}
  </div>
);

PaddedContent.displayName = 'PaddedContent';

export default PaddedContent;



// WEBPACK FOOTER //
// ./src/ui/components/padded-content/padded-content.tsx